// Mock data for Laurel Run Management Group website

export const mockData = {
  company: {
    name: "Laurel Run Management Group",
    email: "Office@lrmgmt.net",
    phone: "(606) 683-3100",
  fax: "(606) 683-3300",
    businessHours: "Monday - Friday: 9:00 AM - 5:00 PM",
    tagline: "Professional Property Management You Can Trust"
  },
  
  hero: {
    title: "PROFESSIONAL PROPERTY MANAGEMENT",
    subtitle: "Protecting Your Investment, Maximizing Your Returns",
    description: "Comprehensive property management services for residential and commercial properties. We handle every aspect of your property so you don't have to.",
    cta1: "Property Management Services",
    cta2: "Contact Our Office"
  },
  
  services: [
    {
      id: 1,
      title: "Residential Property Management",
      description: "Complete oversight of single-family homes, apartments, and multi-unit residential properties. From tenant screening to lease enforcement, we ensure your residential investments perform at their best.",
      icon: "Home"
    },
    {
      id: 2,
      title: "Commercial Property Management",
      description: "Professional management for office buildings, retail spaces, and commercial properties. We maintain property value while ensuring tenant satisfaction and compliance.",
      icon: "Building"
    },
    {
      id: 3,
      title: "Tenant Placement & Screening",
      description: "Rigorous tenant screening process including background checks, credit verification, employment history, and rental references to ensure quality tenants for your property.",
      icon: "UserCheck"
    },
    {
      id: 4,
      title: "Rent Collection & Financial Reporting",
      description: "Streamlined rent collection with multiple payment options, late payment enforcement, and detailed monthly financial reports providing complete transparency.",
      icon: "DollarSign"
    },
    {
      id: 5,
      title: "Maintenance Coordination",
      description: "24/7 maintenance response system with vetted contractors and in-house technicians. Preventive maintenance programs to protect your property value long-term.",
      icon: "Wrench"
    },
    {
      id: 6,
      title: "Compliance & Lease Enforcement",
      description: "Expert handling of lease agreements, compliance with local regulations, and professional enforcement of lease terms to protect your interests.",
      icon: "FileText"
    }
  ],
  
  ownerBenefits: [
    {
      title: "Transparent Communication",
      description: "Regular updates, detailed reporting, and direct access to your property manager. You'll always know what's happening with your investment."
    },
    {
      title: "Maximize Property Value",
      description: "Strategic maintenance, quality tenant placement, and market-rate pricing ensure your property generates optimal returns."
    },
    {
      title: "Professional Systems",
      description: "Time-tested processes for every aspect of property management, from marketing to maintenance, ensuring consistent professional service."
    },
    {
      title: "Minimize Time Commitment",
      description: "We handle tenant calls, maintenance emergencies, inspections, and all day-to-day operations so you can focus on growing your portfolio."
    }
  ],
  
  tenantInfo: {
    applicationProcess: [
      "Submit online rental application with required documentation",
      "Background and credit screening (typically completed within 48 hours)",
      "Application review and approval notification",
      "Lease signing and move-in coordination"
    ],
    rentPayment: "Multiple convenient payment options including online portal, automatic ACH transfer, and traditional check payment.",
    maintenanceRequests: "24/7 online maintenance request system with prompt response times. Emergency maintenance available around the clock.",
    leaseExpectations: "Clear lease terms, professional communication, and fair enforcement of community standards."
  },
  
  about: {
    mission: "Laurel Run Management Group is dedicated to providing superior property management services that protect and enhance our clients' real estate investments. We combine professional expertise with responsive service to deliver results that exceed expectations.",
    values: [
      "Integrity in all business dealings",
      "Professionalism in every interaction",
      "Commitment to excellence",
      "Responsive client service",
      "Long-term relationship building"
    ],
    experience: "With extensive experience in both residential and commercial property management, our team brings the knowledge and systems necessary to handle properties of all types and sizes. We stay current with industry best practices, legal requirements, and market trends to serve our clients effectively."
  },
  
  testimonials: [
    {
      id: 1,
      name: "Michael Richardson",
      role: "Property Owner - 8 Units",
      text: "Laurel Run Management Group transformed how I manage my rental properties. Their professional approach and detailed reporting give me complete confidence in my investment.",
      rating: 5
    },
    {
      id: 2,
      name: "Sarah Thompson",
      role: "Commercial Property Owner",
      text: "Outstanding property management service. They handle everything from tenant relations to maintenance coordination with true professionalism. Highly recommended.",
      rating: 5
    },
    {
      id: 3,
      name: "David Chen",
      role: "Multi-Family Property Owner",
      text: "After working with several property management companies, Laurel Run stands out for their transparency, communication, and results. Best decision I made for my properties.",
      rating: 5
    }
  ],
  
  faq: [
    {
      question: "What types of properties do you manage?",
      answer: "We manage residential properties including single-family homes, apartments, condos, townhouses, and multi-unit buildings, as well as commercial properties including office buildings and retail spaces."
    },
    {
      question: "What are your management fees?",
      answer: "Our fee structure is competitive and transparent. We offer customized management packages based on property type, size, and specific needs. Contact us for a detailed proposal tailored to your property."
    },
    {
      question: "How do you screen tenants?",
      answer: "Our comprehensive screening process includes credit checks, criminal background verification, employment and income verification, rental history review, and personal references. We maintain high standards to ensure quality tenants."
    },
    {
      question: "How quickly do you handle maintenance requests?",
      answer: "Emergency maintenance receives immediate attention 24/7. Routine maintenance requests are typically addressed within 24-48 hours. We maintain relationships with licensed, insured contractors for quality service."
    },
    {
      question: "When do property owners receive their payments?",
      answer: "Rent payments are typically disbursed to owners by the 10th of each month, accompanied by detailed financial statements showing all income and expenses for the previous month."
    },
    {
      question: "What is your lease enforcement policy?",
      answer: "We enforce lease terms professionally and consistently, following all applicable laws. This includes timely late fee assessment, formal notices for lease violations, and when necessary, coordination of the eviction process."
    }
  ],
  
  serviceAreas: [
    "Richmond Metro Area",
    "Northern Virginia",
    "Hampton Roads Region",
    "Charlottesville Area",
    "Fredericksburg Region",
    "Lynchburg Area"
  ]
};
